/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import React, { useState, useMemo, useContext } from 'react'
import {
  unitIdHeader,
  modifierCol,
  modifiedDateCol,
} from 'core/HeaderColTypeProps'
import { dateCol, numCol } from '@integec/grid-tools/lib/cols'
import {
  retrieveMakeWholeCredit,
  deleteMakeWholeCredit,
  saveMakeWholeCredit,
} from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  hasAccesPermits,
} from 'core'
import { CriteriaRow } from 'core/screen-util'
import { Button, DatePicker, InputNumber } from 'antd'
import * as Actions from 'core/EventActions'
import CommonScreen from 'admin/component/CommonScreen'

import MarginAnalysisUtilityUnitSelection from './../MarginAnalysisUtilityUnitSelection'
import { PNodeZoneContext } from 'context'

const title = 'Make Whole Credit'

const Label = styled.div`
  display: grid;
  justify-content: end;
  align-content: center;
`

const headers = [
  //   strCol({ ident: 'unitid', display: 'Unitid', isKey: true, sortOrder: 'asc' }),
  unitIdHeader,
  dateCol({
    ident: 'transdate',
    display: 'Trans Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  numCol({
    ident: 'credit',
    display: 'Credit',
    isFiltered: true,
    // displayFormat: '0.00',
    sortOrder: 'asc',
    width: 150,
    isRequired: true,
  }),
  modifierCol,
  modifiedDateCol,
]

// eslint-disable-next-line no-unused-vars
const MakeWholeCredit = ({
  // targetInfo,
  envConfig,
  actionPermits,
  // eslint-disable-next-line no-unused-vars
  ...props
}) => {
  // const { selectedUnits } = useContext(UnitSelectionContext)

  const [insertEvent, setInsertEvent] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [editMode, setEditMode] = useState(true)

  const { unitIdEmktIdMap, marginUnitsList, emktIdUnitNameMap } = useContext(
    PNodeZoneContext
  )
  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <CriteriaRow>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '50px 400px 100px 150px 120px 150px 100px 180px 100px',
          gridGap: '5px',
        }}
      >
        <Label>Unit:</Label>

        <MarginAnalysisUtilityUnitSelection
          utility={insertData.utility || null}
          unit={insertData.unit || null}
          onUnitChange={value => {
            // setUtilityUnit(value)
            setInsertData({
              ...insertData,
              utility: value[0],
              unit: value[1],
              unitId: unitIdEmktIdMap[value[1]],
            })
          }}
          style={{ width: '100%' }}
        />

        <Label>Trans Date:</Label>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={insertData.effectivedateObj}
          onChange={date => {
            setInsertData({
              ...insertData,
              transdate: date.format('YYYY-MM-DD'),
              effectivedateObj: date,
            })
          }}
          style={{ width: '100%' }}
        />
        <Label>Credit:</Label>
        <InputNumber
          style={{ width: '100%' }}
          defaultValue={0}
          value={insertData.credit}
          onChange={value => setInsertData({ ...insertData, credit: value })}
          // max={9}
        />

        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </CriteriaRow>
  )

  const headerWithFormatter = headers.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.unitId] ||
            emktIdUnitNameMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header
  )

  const writeEventActionPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          Actions.MARGIN_ANALYSIS_ADMIN,
          Actions.MARGIN_ANALYSIS_CORE_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const writePermission = useMemo(_ => writeEventActionPermission && editMode, [
    writeEventActionPermission,
    editMode,
  ])

  const withCriteria = (state, props, selectedUnits, selectedDate) => {
    return {
      date: selectedDate,
      units: (selectedUnits || [])
        .filter(e => !!e)
        .map(e => unitIdEmktIdMap[e.unitId]),
    }
  }

  // writeEventActionPermission ? (
  //   <Checkbox
  //     css={{ marginLeft: '10px', minWidth: '100px' }}
  //     onChange={e => setEditMode(e.target.checked)}
  //     checked={editMode}
  //   >
  //     Edit Mode
  //   </Checkbox>
  // ) : (
  //   <div />
  // )

  const extraUnitSelectionProps = _ => ({
    limitedUnits: marginUnitsList,
    units: marginUnitsList,
    // itemToLabel: e => e.emktId,
  })

  // const modifySaveDataBeforeSave = (saveData, validateData) => {
  //   return saveData.map(s => ({ ...s, unitId: emktUnitMap[s.unitId] }))
  // }

  // eslint-disable-next-line no-unused-vars
  const isEditableGrid = ({ header, rowData }) => {
    if (
      header.ident === 'modifier' ||
      header.ident === 'modifiedDate' ||
      header.isKey
    )
      return false

    return writePermission
  }

  return (
    <div>
      <CommonScreen
        // modifySaveDataBeforeSave={modifySaveDataBeforeSave}
        withoutModify={!writeEventActionPermission}
        withDelete={!writeEventActionPermission}
        allowInsert={writeEventActionPermission}
        isEditableGrid={isEditableGrid}
        extraUnitSelectionProps={extraUnitSelectionProps}
        withUnitSelection
        // withDatePickerTitle="Trans Date : "
        withDatePickerTitle="Effective Date : "
        autoRetrieve={false}
        isAdminScreen={false}
        withCriteria={withCriteria}
        withDatePicker
        title={title}
        header={headerWithFormatter}
        saveTask={saveMakeWholeCredit}
        retrieveTask={retrieveMakeWholeCredit}
        deleteTask={deleteMakeWholeCredit}
        altBy={u => u.unitId}
        sortOptions={headers}
        initialSortOptions={headers}
        widthOffset={50}
        insertComp={insertEvent && insertComp}
        insertCompHeight={120}
        onInsertEvent={b => setInsertEvent(b)}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(MakeWholeCredit)
